<template>
  <div class="wrapper">
    <div>
      <CRow class="mt-3">
        <div></div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <Datatable
                    :items="items"
                    :fields="fields"
                    :meta="meta"
                    @per_page="handlePerPage"
                    @pagination="handlePagination"
                    @search="handleSearch"
                    @sort="handleSort"
                    @is_active="handleIsActive"
                    :btn_show="true"
                    :btn_edit="true"
                    :btn_deactivate="true"
                    :btn_reactivate="true"
                    :btn_delete="false"
                    @show="handleShow"
                    @edit="handleEdit"
                    @deactivate="handleDeactivate"
                    @reactivate="handleReactivate"
                  />
                </div>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
      <alertmodal></alertmodal>
      <peopledetailmodal></peopledetailmodal>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatables_department_join.vue";
import axios from "axios";

import department from "@/services/department";

import alertmodal from "@/views/alert/modal.vue";
import EventBus from "@/eventBus";
import store from "@/store.js";

import peopledetailmodal from "@/views/peoples/people_detail_modal.vue";

const token = localStorage.getItem("token");

export default {
  name: "Department Join Tables",
  components: { Datatable, alertmodal, peopledetailmodal },
  data() {
    return {
      form: {
        name: "",
        city: "",
        state: "",
        country: "",
        zone: "",
        leader: "",
      },
      largeModal: false,
      updateSubmit: false,
      fields: [
        { key: "name", label: "Name", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "status", label: "Status", sortable: false },
        { key: "action", label: "Action", sortable: false },
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: "",
      sortBy: "created_at",
      sortByDesc: false,
      is_active: 1,
    };
  },
  mounted() {
    this.loadData();
    EventBus.$on("TABLE_UPDATE", (data) => {
      if (data) {
        this.loadData();
      }
    });
  },

  methods: {
    loadData() {
      let current_page = this.search == "" ? this.current_page : 1;
      var params = {
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? "DESC" : "ASC",
        is_active: this.is_active,
      };

      department
        .getDepartmentDataSourceJoin(params)
        .then((res) => {
          let getData = res.data;
          this.items = getData.data;
          //this.is_active = res.is_active
          this.meta = {
            total: getData.total,
            current_page: getData.current_page,
            per_page: getData.per_page,
            from: getData.from,
            to: getData.to,
            is_active: res.is_active,
          };
        })
        .catch((err) => {
          var params = {
            title: "Error",
            mode: "danger",
            data: err.response.data.message,
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        });
    },

    openShowPeople(uuid) {
      var params = {
        title: "Detail Personal Information",
        mode: "detail",
        data: uuid,
      };
      EventBus.$emit("OPEN_SHOW_PEOPLE", params);
    },

    deactivate(id) {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (Permission.indexOf("Delete tujuan") !== -1) {
          //IF ALLOW
          if (confirm("Do you really want to change status to done?")) {
            department
              .deactivateJoin(id)
              .then((res) => {
                EventBus.$emit("TABLE_UPDATE", true);
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
      }
      //SET END
    },

    reactivate(id) {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (Permission.indexOf("Delete tujuan") !== -1) {
          //IF ALLOW
          if (confirm("Do you really want to change status to pending?")) {
            department
              .reactivateJoin(id)
              .then((res) => {
                EventBus.$emit("TABLE_UPDATE", true);
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
      }
      //SET END
    },

    handlePerPage(val) {
      this.per_page = val;
      this.loadData();
    },

    handlePagination(val) {
      this.current_page = val;
      this.loadData();
    },

    handleSearch(val) {
      this.search = val;
      this.current_page = 1;
      this.loadData();
    },

    handleSort(val) {
      this.sortBy = val.sortBy;
      this.sortByDesc = val.sortDesc;
      this.loadData();
    },

    handleIsActive(val) {
      this.is_active = val;
      this.loadData();
    },

    ////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
      this.openShowPeople(val);
    },

    handleDeactivate(val) {
      this.deactivate(val);
    },

    handleReactivate(val) {
      this.reactivate(val);
    },
  },
};
</script>
